import { r as registerInstance, h, H as Host } from './index-5faac9d7.js';
import { t as tryParse } from './index-39f51a91.js';
import { B as Brand } from './types-66e6568b.js';
import { g as getContextDirection } from './contextDirection-33f260e3.js';
import './currency-49e0d692.js';
import './_commonjsHelpers-7db8bc26.js';
import './analytics-b3108572.js';
import './lodash-7f024380.js';
import './_nodeUtil-549406aa.js';
import './_Stack-cf94d4e7.js';
import './types-e54f4a51.js';

const APCProductDatasheet = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.apcProductsAll = undefined;
    this.apcPdfEpds = undefined;
    this.apcPdsAdditionalData = undefined;
    this.apcContextDirection = undefined;
    this._apcProductsAll = undefined;
    this._apcPdfEpds = undefined;
    this._apcPdsAdditionalData = undefined;
  }
  componentWillLoad() {
    var _a, _b, _c;
    this.apcProductsAll = (_a = tryParse(this._apcProductsAll)) !== null && _a !== void 0 ? _a : this.apcProductsAll;
    this.apcPdfEpds = (_b = tryParse(this._apcPdfEpds)) !== null && _b !== void 0 ? _b : this.apcPdfEpds;
    this.apcPdsAdditionalData = (_c = tryParse(this._apcPdsAdditionalData)) !== null && _c !== void 0 ? _c : this.apcPdsAdditionalData;
  }
  render() {
    var _a;
    if (!this.apcProductsAll)
      return;
    const { productInfo, productCR, productMedia, highlightedCharacteristics, ctaArea, productStatus, } = this.apcProductsAll.base;
    const { characteristicTables, productCharacteristicsLabel, } = this.apcProductsAll.specifications || {};
    const { sustainability, environmentalData, dataSheetDate, dataSheetTitle, dataSheetDisclaimer, dataSheetPriceLabel, specifications, } = this.apcProductsAll;
    const { greenPremiumLogo } = this.apcProductsAll.base.sustainability || {};
    const configDirection = (_a = this.apcProductsAll.config) === null || _a === void 0 ? void 0 : _a.direction;
    this.apcContextDirection = getContextDirection(configDirection);
    const { pdfIcons } = this.apcPdsAdditionalData;
    return (h(Host, null, h("pes-product-datasheet", { showHeader: true, showDisclaimer: true, showWeeePriceLabel: true, specifications: specifications, sustainability: sustainability, environmentalData: environmentalData, date: dataSheetDate, title: dataSheetTitle, disclaimer: dataSheetDisclaimer, priceLabel: dataSheetPriceLabel, productInfo: productInfo, productCr: productCR, productMedia: productMedia, highlightedCharacteristics: highlightedCharacteristics, ctaArea: ctaArea, subtitle: productCharacteristicsLabel, characteristicTables: characteristicTables || [], greenPremiumLogo: greenPremiumLogo, pdfEpds: this.apcPdfEpds, productStatus: productStatus, brand: Brand.apc, contextDirection: this.apcContextDirection, pdfIcons: pdfIcons })));
  }
};

export { APCProductDatasheet as pes_apc_product_datasheet };
